import api from 'libs/axios/api';
import { apiService } from 'libs/axios/services';

export const getProcessingList = async (
    request: ProcessingListRequest,
): Promise<ApiResponse<ProcessingListResponse>> => {
    return apiService.get<ProcessingListRequest, ProcessingListResponse>(
        api.processingList,
        request,
        undefined,
        true,
    );
};

export const getProcessingListDetail = async (
    task_id: string,
): Promise<ApiResponse<ProcessingListDetailResponse>> => {
    return apiService.get<undefined, ProcessingListDetailResponse>(
        `${api.processingTask}/${task_id}`,
    );
};

export const deleteProcessingTask = async (
    task_ids: string[],
): Promise<ApiResponse<IUpdateDeleteProcessing>> => {
    const idsToDelete = { task_ids };
    return apiService.delete<typeof idsToDelete, IUpdateDeleteProcessing>(
        api.processingList,
        undefined,
        idsToDelete,
        undefined,
        true,
    );
};

export const updateProcessingOutputAPI = async (
    task_id: string,
    request: IUpdateProcessingRequest,
): Promise<ApiResponse<any>> => {
    return apiService.put<IUpdateProcessingRequest, any>(
        `/processing-task/${task_id}/processing-output`,
        request,
        undefined,
        true,
    );
};

export const updateProcessingInputAPI = async (
    task_id: string,
    request: IUpdateProcessingRequest,
): Promise<ApiResponse<any>> => {
    return apiService.put<IUpdateProcessingRequest, any>(
        `/processing-task/${task_id}`,
        request,
        undefined,
        true,
    );
};
